import React, { useState, useEffect } from 'react';
import { useTheme } from '../../contexts/ThemeContext';

export default function PriceFilter({ minPrice, maxPrice, onChange }) {
  const { theme } = useTheme();
  const [min, setMin] = useState(minPrice || '');
  const [max, setMax] = useState(maxPrice || '');

  useEffect(() => {
    setMin(minPrice || '');
    setMax(maxPrice || '');
  }, [minPrice, maxPrice]);

  const handleBlur = () => {
    // Auto-apply when user finishes typing
    if (min !== (minPrice || '') || max !== (maxPrice || '')) {
      onChange({
        minPrice: min || null,
        maxPrice: max || null,
      });
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleBlur();
    }
  };

  return (
    <div>
      <label className={`block text-sm font-medium mb-2 ${theme.text}`}>
        Price Range
      </label>
      <div className="flex gap-2 items-center">
        <div className="relative flex-1">
          <span className={`absolute left-3 top-1/2 -translate-y-1/2 ${theme.textSecondary}`}>$</span>
          <input
            type="number"
            placeholder="Min"
            value={min}
            onChange={(e) => setMin(e.target.value)}
            onBlur={handleBlur}
            onKeyDown={handleKeyDown}
            className={`w-full pl-7 pr-3 py-2 rounded-lg border ${theme.border} ${theme.card} ${theme.text} focus:outline-none focus:ring-2 focus:ring-blue-500`}
            min="0"
          />
        </div>
        <span className={`${theme.textSecondary}`}>-</span>
        <div className="relative flex-1">
          <span className={`absolute left-3 top-1/2 -translate-y-1/2 ${theme.textSecondary}`}>$</span>
          <input
            type="number"
            placeholder="Max"
            value={max}
            onChange={(e) => setMax(e.target.value)}
            onBlur={handleBlur}
            onKeyDown={handleKeyDown}
            className={`w-full pl-7 pr-3 py-2 rounded-lg border ${theme.border} ${theme.card} ${theme.text} focus:outline-none focus:ring-2 focus:ring-blue-500`}
            min="0"
          />
        </div>
      </div>
    </div>
  );
}
